import usePostData from '../../../hooks/postHook';

export const useUpdateNotification = () => {
  const [{}, doUpdateStatusAll] = usePostData(`notifications/status`, {
    type: 'put',
  });
  return { doUpdateStatusAll };
};
